import React, { useEffect, useState } from "react";
import { DailyDiary, SleepTimeLogs } from "src/shared/types/src"
import LocalImages from '../../static';
import { convertDurationToSeconds, convertSecondsToTimeString } from "src/shared/utils/src";
import MediaCollageContainer from "./mediaCollage/MediaCollageContainer";
import { Checkmark, CheckmarkCircle } from "react-ionicons";
import TextRenderer from "./TextRenderer";

const DailyDiaryDetails = ({ details }: { details: DailyDiary }) => {

  const [sleepTimeTotal, setSleepTimeTotal] = useState<string>('');
  const [totalBottleQuantity, setTotalBottleQuantity] = useState<string>('');

  useEffect(() => {
    let total = 0;
    if (details?.sleepTimes?.logs?.length > 0) {
      for (let i = 0; i < details?.sleepTimes?.logs?.length; i++) {
        const log = details?.sleepTimes?.logs[i];
        const startTime = convertDurationToSeconds(log?.start?.value ?? '0');
        const endTime = convertDurationToSeconds(log?.end?.value ?? '0');
        total += endTime - startTime;
      }
    }
    setSleepTimeTotal(convertSecondsToTimeString(total));
  }, [details?.sleepTimes?.logs]);

  useEffect(() => {
    let total = 0;
    if (details?.bottleLogs?.logs?.length > 0) {
      for (let i = 0; i < details?.bottleLogs?.logs?.length; i++) {
        const log = details?.bottleLogs?.logs[i];
        total += Number(log?.quantity?.value) ?? 0;
      }
    }
    setTotalBottleQuantity(`${total} ${details?.bottleLogs?.logs[0]?.unit ?? 'mL'}`);
  }, [details?.bottleLogs?.logs]);

  const getSleepTimeIndividualLogTotal = (log: SleepTimeLogs) => {
    const startTime = convertDurationToSeconds(log?.start?.value ?? '0');
    const endTime = convertDurationToSeconds(log?.end?.value ?? '0');
    const totalTimeInSeconds = endTime - startTime;
    const timeString = convertSecondsToTimeString(totalTimeInSeconds);
    return timeString;
  }

  const BorderDashed = () => {
    return (
      <div>
        {/* // Array.from({ length: windowWidth }, (_, i) => 
            //     <View style={ commonStyles.dailyDiaryBorderDashItem } key={ i } />
            ) */}
      </div>
    )
  }

  return (
    <>
      {
        ((details?.meals?.items?.length > 0) || (details?.meals?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.fruitIcon} alt="fruitIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details.meals.label ?? 'What I ate today?'}</div>
              </div>
              <div className="mg-t-18">
                {
                  details?.meals?.items?.map((item, index) =>
                    <div className="daily-diary-item" key={index}>
                      <div className="d-flex justify-content-between">
                        <p className="mg-b-0 fw-semibold fs-12">{item.label}</p>
                        <span className="fs-12 text-gray-300">{item.quantity || '-'}</span>
                      </div>
                      <p className="mg-b-0 fs-12 text-black mg-t-5">{item.description || '-'}</p>
                    </div>
                  )
                }
              </div>
              {
                details?.meals?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.meals?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }
      {
        ((details?.sleepTimes?.logs?.length > 0) || (details?.sleepTimes?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="d-flex align-items-center">
                <div className="section-with-img flex-1 pd-r-15">
                  <div className="section-img"><img src={LocalImages.sleepingIcon} alt="sleepingIcon" /></div>
                  <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details?.sleepTimes?.label ?? 'Sleep Times'}</div>
                </div>
                <div className="fs-12 text-gray-300">{sleepTimeTotal}</div>
              </div>
              <div className="mg-t-18">
                {
                  details?.sleepTimes?.logs?.map((item, index) =>
                    <div className="daily-diary-item" key={index}>
                      <div className="d-flex justify-content-between">
                        <p className="mg-b-0 fs-12 text-gray-300">{item.start.value ?? ''} - {item.end.value ?? ''}</p>
                        <span className="fs-12 text-gray-300">{getSleepTimeIndividualLogTotal(item)}</span>
                      </div>
                    </div>
                  )
                }
              </div>
              {
                details?.sleepTimes?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.sleepTimes?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }

      {
        ((details?.bottleLogs?.logs?.length > 0) || (details?.bottleLogs?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="d-flex align-items-center">
                <div className="section-with-img flex-1 pd-r-15">
                  <div className="section-img"><img src={LocalImages.babyBottleIcon} alt="babyBottleIcon" /></div>
                  <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details?.bottleLogs?.label ?? 'I had my bottle'}</div>
                </div>
                <div className="fs-12 text-black">{totalBottleQuantity}</div>
              </div>
              <div className="mg-t-13">
                {
                  details?.bottleLogs?.logs?.map((item, index) =>
                    <div className="daily-diary-item" key={index}>
                      <p className="mg-b-0 fs-12 text-gray-300">{item.time.value ?? '-'}</p>
                      <span className="fs-12 text-black">{item.quantity.value ?? '-'} {item.unit ?? 'mL'}</span>
                    </div>
                  )
                }
              </div>
              {
                details?.bottleLogs?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.bottleLogs?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }

      {
        ((details?.nappies?.logs?.length > 0) || (details?.nappies?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.babyDiaperIcon} alt="babyDiaperIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details?.nappies?.label ?? 'Nappies'}</div>
              </div>
              <div className="mg-t-13">
                {
                  details?.nappies?.logs?.map((item, index) =>
                    <div className="daily-diary-item" key={index}>
                      <div className="fs-12 text-gray-300">{item.when.time ?? '-'}</div>
                      <div className="d-flex align-items-center">
                        <div className="fs-12 text-black w-20">{item.condition ?? '-'}</div>
                        {
                          item?.nappyRash ?
                            <div className="w-40">
                              <div className="d-flex align-items-center">
                                <div className="rounded-circle checkmark mg-r-5"><Checkmark
                                  color={'#000000'}
                                  height="12px"
                                  width="12px"
                                /></div>
                                <p className="mg-b-0 fs-12 text-black">Nappy Rash</p>
                              </div></div> : null
                        }
                        {
                          item?.creamApplied ?
                          <div className="w-40">
                            <div className="d-flex align-items-center">
                              <div className="rounded-circle checkmark mg-r-5"><Checkmark
                                color={'#000000'}
                                height="12px"
                                width="12px"
                              /></div>
                              <p className="mg-b-0 fs-12 text-black">Cream Applied</p>
                            </div> </div> : null
                        }
                      </div>
                    </div>
                  )
                }
              </div>
              {
                details?.nappies?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.nappies?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }
      {
        ((details?.toileting?.logs?.length > 0) || (details?.toileting?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.toiletBowlIcon} alt="toiletBowlIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details?.toileting?.label ?? 'Toileting'}</div>
              </div>
              {
                details?.toileting?.logs?.map((item, index) =>
                  <div className="mg-t-13">
                    <p className="fs-12 text-gray-300 mb-0">{item.time.value ?? '-'}</p>
                    <p className="fs-12 text-black mb-0 mg-t-5">{item.wentOn ?? 'N/A'}</p>
                  </div>
                )
              }
              {
                details?.toileting?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.toileting?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }

      {
        ((details?.sunCream?.logs?.length > 0) || (details?.sunCream?.notes)) ?
          <>
            <div className="daily-diary-item-container">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.sunCreamIcon} alt="sunCreamIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">{details?.sunCream?.label ?? 'Sun Cream'}</div>
              </div>
              <div className="mg-t-13">
                {
                  details?.sunCream?.logs?.map((item, index) =>
                    <div className="daily-diary-item" key={index}>
                      <p className="mg-b-0 fs-12 text-gray-300">{item.time.value ?? '-'}</p>
                      <span className="fs-12 text-black">SPF {item.spf ?? '-'}</span>
                    </div>
                  )
                }
              </div>
              {
                details?.sunCream?.notes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.sunCream?.notes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }

      {
        details?.notes?.toParents ?
          <>
            <div className="daily-diary-item-container mg-t-10">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.notesIcon} alt="notesIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">Notes to parent</div>
              </div>
              <div className="mg-t-15 fs-12 text-black"><TextRenderer text={details?.notes?.toParents ?? 'N/A'} /></div>
            </div>
          </> : null
      }
      {
        details?.notes?.fromParents ?
          <>
            <div className="daily-diary-item-container mg-t-10">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.notesIcon} alt="notesIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">Notes from parent</div>
              </div>
              <div className="mg-t-15 fs-12 text-black"><TextRenderer text={details?.notes?.fromParents ?? 'N/A'} /></div>
            </div>
          </> : null
      }
      {
        ((details?.media?.length > 0) || (details?.notes?.mediaNotes)) ?
          <>
            <div className="daily-diary-item-container mg-t-10">
              <div className="section-with-img flex-1 pd-r-15">
                <div className="section-img"><img src={LocalImages.photoIcon} alt="photoIcon" /></div>
                <div className="fs-12 fw-semibold text-black flex-1 pd-l-10">Daily Diary Media</div>
              </div>
              <div>
                <MediaCollageContainer media={details.media} openCarousel={true} />
              </div>
              {
                details?.notes?.mediaNotes ?
                  <>
                    <div className="mg-t-15 fs-12 text-black">Notes: <TextRenderer text={details?.notes?.mediaNotes ?? 'N/A'} /></div>
                  </> : null
              }
            </div>
          </> : null
      }
    </>
  )
}

export default DailyDiaryDetails;